module.exports = __webpack_public_path__ + "img/checkout-shirt.e6d4ebce.svg";